
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire334f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire334f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $1a7bdc4e2b90c511$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["auyDg","index.5ffc7d71.js","iumYM","star.7cf291c8.svg","WRKDL","demo.ec2649f9.svg","jTpcn","code.ca891a6b.svg"]'));

var $0a8e117df5e3101b$exports = {};
$0a8e117df5e3101b$exports = new URL("star.7cf291c8.svg", import.meta.url).toString();


var $1217f1aea9c72452$exports = {};
$1217f1aea9c72452$exports = new URL("demo.ec2649f9.svg", import.meta.url).toString();


var $c760d5866db31515$exports = {};
$c760d5866db31515$exports = new URL("code.ca891a6b.svg", import.meta.url).toString();


let $2b6e161c9edcf319$var$msg = "%c Hi \uD83D\uDC4B! Welcome to my Portfolio, hope you will enjoy it!\uD83D\uDE0A";
let $2b6e161c9edcf319$var$styles = [
    "font-size: 12px",
    "font-family: monospace",
    "background: #020916",
    "display: inline-block",
    "color: #70FF00",
    "padding: 8px 19px",
    "border: 1px dashed"
].join(";");
console.log($2b6e161c9edcf319$var$msg, $2b6e161c9edcf319$var$styles);
const $2b6e161c9edcf319$var$projectContainer = document.querySelector(".project--js");
const $2b6e161c9edcf319$var$username = "NoriFe";
const $2b6e161c9edcf319$var$description = "";
fetch(`https://api.github.com/users/${$2b6e161c9edcf319$var$username}/repos`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { description: description, homepage: homepage, html_url: html_url, name: name, stargazers_count: stargazers_count, topics: topics } = repository;
        let tags = ``;
        for (let tag of topics)tags += `<li class="bg-gray-400/10 py-1 px-2 rounded text-sm font-bold">${tag}</li>`;
        const element = `<article class="rounded-rad md:rounded-rad-xl overflow-clip bg-gradient-to-br from-white/10 to-white/5 flex flex-col h-full">
<div class="border-b border-bg shadow-inner-light rounded-t-rad md:rounded-t-rad-xl flex gap-1.5 p-4 h-11 bg-gradient-to-br from-white/10 to-white/5 ">
    <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
    <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
    <span class="w-3 h-3 block rounded-full bg-bg opacity-50"></span>
</div>
<div class="p-5 md:p-6 lg:p-10 flex flex-col justify-between grow ring-1 ring-inset ring-bg">
<div>
    <header class="mb-4 flex gap-4 items-center">
<h3 class="text-2xl leading-none font-bold">${name}</h3>
<p class=" bg-gray-400/10 py-1 px-2 flex gap-0.5 items-center
 text-gray-400 font-medium leading-none rounded">
 <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($0a8e117df5e3101b$exports)))}" alt="" class="w-4 h-4" />${stargazers_count}</p>
</header>
<p class="text-gray-400 text-xl mb-4">
${description}
</p>
<ul class="flex gap-2 mb-10 flex-wrap">
${tags}

</ul>
</div>
<div class="flex flex-col flex-wrap md:flex-row gap-4 items-start">
<a class="bg-bg text-accent border-gray-800 border-2 flex gap-3 font-bold  
py-4 px-5 items-center rounded-rad md:rounded-rad-xl md:text-xl hover:border-accent transition-colors duration-500" rel="noreferrer nofollow" target="_blank" 
href="${homepage}"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($1217f1aea9c72452$exports)))}" class="w-6 h-6" width="24" height="24"alt=""> View demo</a>
<a class="bg-bg text-accent border-gray-800 border-2 flex gap-3 font-bold  
py-4 px-5 items-center rounded-rad md:rounded-rad-xl md:text-xl hover:border-accent transition-colors duration-500" rel="noreferrer nofollow" target="_blank" 
href="${html_url}"><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($c760d5866db31515$exports)))}" class="w-6 h-6" width="24" height="24" alt="">Source code</a>
</div>
</article>`;
        if (description) $2b6e161c9edcf319$var$projectContainer.insertAdjacentHTML("afterbegin", element);
    }
}).catch((e)=>console.log(e));
const $2b6e161c9edcf319$var$aiLauncher = document.querySelector("#aiLauncher");
const $2b6e161c9edcf319$var$aiChatPanel = document.querySelector("#aiChatPanel");
const $2b6e161c9edcf319$var$aiChatClose = document.querySelector("#aiChatClose");
const $2b6e161c9edcf319$var$aiChatInput = document.querySelector("#aiChatInput");
const $2b6e161c9edcf319$var$aiChatComposer = document.querySelector(".ai-chat-panel__composer");
const $2b6e161c9edcf319$var$aiChatMessages = document.querySelector("#aiChatMessages");
const $2b6e161c9edcf319$var$aiChatSend = document.querySelector("#aiChatSend");
const $2b6e161c9edcf319$var$chatHistory = [];
const $2b6e161c9edcf319$var$addChatMessage = (role, text, extraClass = "")=>{
    if (!$2b6e161c9edcf319$var$aiChatMessages) return null;
    const messageNode = document.createElement("article");
    const roleClass = role === "user" ? "ai-chat-message--user" : "ai-chat-message--bot";
    messageNode.className = `ai-chat-message ${roleClass}${extraClass ? ` ${extraClass}` : ""}`;
    messageNode.textContent = text;
    $2b6e161c9edcf319$var$aiChatMessages.appendChild(messageNode);
    $2b6e161c9edcf319$var$aiChatMessages.scrollTop = $2b6e161c9edcf319$var$aiChatMessages.scrollHeight;
    return messageNode;
};
const $2b6e161c9edcf319$var$setComposerState = (isSending)=>{
    if ($2b6e161c9edcf319$var$aiChatSend) $2b6e161c9edcf319$var$aiChatSend.disabled = isSending;
    if ($2b6e161c9edcf319$var$aiChatInput) $2b6e161c9edcf319$var$aiChatInput.disabled = isSending;
};
const $2b6e161c9edcf319$var$requestChatReply = async (message)=>{
    const response = await fetch("/api/chat", {
        method: "POST",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify({
            message: message,
            history: $2b6e161c9edcf319$var$chatHistory
        })
    });
    const payload = await response.json().catch(()=>({}));
    if (!response.ok) throw new Error(payload.error || "Chat service unavailable");
    return payload.reply;
};
if ($2b6e161c9edcf319$var$aiLauncher) {
    const aiLauncherWrap = $2b6e161c9edcf319$var$aiLauncher.closest(".ai-launcher-wrap");
    const syncLauncherState = ()=>{
        const isExpanded = $2b6e161c9edcf319$var$aiLauncher.getAttribute("aria-expanded") === "true";
        if (aiLauncherWrap) aiLauncherWrap.classList.toggle("is-open", isExpanded);
        if ($2b6e161c9edcf319$var$aiChatPanel) $2b6e161c9edcf319$var$aiChatPanel.setAttribute("aria-hidden", String(!isExpanded));
        if (isExpanded && $2b6e161c9edcf319$var$aiChatInput) window.setTimeout(()=>$2b6e161c9edcf319$var$aiChatInput.focus(), 140);
    };
    syncLauncherState();
    $2b6e161c9edcf319$var$aiLauncher.addEventListener("click", ()=>{
        const isExpanded = $2b6e161c9edcf319$var$aiLauncher.getAttribute("aria-expanded") === "true";
        const nextState = !isExpanded;
        $2b6e161c9edcf319$var$aiLauncher.setAttribute("aria-expanded", String(nextState));
        syncLauncherState();
    });
    if ($2b6e161c9edcf319$var$aiChatClose) $2b6e161c9edcf319$var$aiChatClose.addEventListener("click", ()=>{
        $2b6e161c9edcf319$var$aiLauncher.setAttribute("aria-expanded", "false");
        syncLauncherState();
        $2b6e161c9edcf319$var$aiLauncher.focus();
    });
    if ($2b6e161c9edcf319$var$aiChatComposer) $2b6e161c9edcf319$var$aiChatComposer.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const value = ($2b6e161c9edcf319$var$aiChatInput?.value || "").trim();
        if (!value) return;
        $2b6e161c9edcf319$var$addChatMessage("user", value);
        $2b6e161c9edcf319$var$chatHistory.push({
            role: "user",
            text: value
        });
        if ($2b6e161c9edcf319$var$aiChatInput) $2b6e161c9edcf319$var$aiChatInput.value = "";
        $2b6e161c9edcf319$var$setComposerState(true);
        const typingNode = $2b6e161c9edcf319$var$addChatMessage("assistant", "Thinking...", "ai-chat-message--typing");
        try {
            const reply = await $2b6e161c9edcf319$var$requestChatReply(value);
            if (typingNode) typingNode.remove();
            $2b6e161c9edcf319$var$addChatMessage("assistant", reply);
            $2b6e161c9edcf319$var$chatHistory.push({
                role: "assistant",
                text: reply
            });
        } catch (error) {
            if (typingNode) typingNode.remove();
            const fallback = "I had trouble reaching the chat service. Please try again in a moment.";
            $2b6e161c9edcf319$var$addChatMessage("assistant", fallback);
            $2b6e161c9edcf319$var$chatHistory.push({
                role: "assistant",
                text: fallback
            });
        } finally{
            $2b6e161c9edcf319$var$setComposerState(false);
            if ($2b6e161c9edcf319$var$aiChatInput) $2b6e161c9edcf319$var$aiChatInput.focus();
        }
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && $2b6e161c9edcf319$var$aiLauncher.getAttribute("aria-expanded") === "true") {
            $2b6e161c9edcf319$var$aiLauncher.setAttribute("aria-expanded", "false");
            syncLauncherState();
            $2b6e161c9edcf319$var$aiLauncher.focus();
        }
    });
}


//# sourceMappingURL=index.5ffc7d71.js.map
